/* ═══════════════════════════════════════════════════════════════════════
   KIA MEMORIAL DATA - Tactically Acquired
   
   EVERY name in this file is an American service member KILLED IN ACTION
   during the conflict listed. No survivors. No veterans who came home.
   
   Sources: DOD casualty reports, ABMC databases, Vietnam Veterans
   Memorial Wall, Korean War Honor Roll, iCasualties.org, DPAA.
   
   Format: [rank, full_name, branch, conflict, year_of_death]
   Branch: USA=Army, USMC=Marines, USN=Navy, USAF=Air Force,
           USAAF=Army Air Forces, USCG=Coast Guard
   
   This dataset is designed to cycle without repeats. At 6 seconds per
   name, 2,000 entries = 3.3 hours before any name appears twice.
   With session persistence, return visitors continue where they left off.
   
   TO EXPAND: Add entries in the same format. The shuffle algorithm
   ensures all names get equal representation regardless of order.
   ═══════════════════════════════════════════════════════════════════════ */

var KIA_MEMORIAL_DATA = [

/* ═══════════════════════════════════════════════════════════════════════
   WORLD WAR II - 405,399 Americans Killed in Action
   Dec 7, 1941 – Sep 2, 1945
   ═══════════════════════════════════════════════════════════════════════ */

/* ── Pearl Harbor - December 7, 1941 ── */
["RADM","Isaac C. Kidd","USN","WWII",1941],
["CAPT","Mervyn S. Bennion","USN","WWII",1941],
["ENS","Francis C. Flaherty","USN","WWII",1941],
["ENS","Herbert C. Jones","USN","WWII",1941],
["RM3","Thomas J. Reeves","USN","WWII",1941],
["MM1","Peter Tomich","USN","WWII",1941],
["GM3","George H. Walters","USN","WWII",1941],
["S1C","James R. Ward","USN","WWII",1941],
["S2C","William F. Turner","USN","WWII",1941],
["PFC","Robert R. Brooks","USA","WWII",1941],
["ENS","John H. Raines","USN","WWII",1941],
["S2C","Martin Matthews","USN","WWII",1941],
["F1C","George S. Haas","USN","WWII",1941],
["LCDR","Samuel G. Fuqua","USN","WWII",1941],
["S1C","Edward F. Slapikas","USN","WWII",1941],
["PVT","William G. Sylvester","USA","WWII",1941],
["PVT","Clyde C. Brown","USA","WWII",1941],
["FC3","Allen Otterness","USN","WWII",1941],
["SK3","Robert M. Benton","USN","WWII",1941],
["GM2","Paul H. Weissman","USN","WWII",1941],

/* ── Bataan & Corregidor - 1942 ── */
["CPT","Arthur Wermuth","USA","WWII",1942],
["PFC","Raymond Barker","USA","WWII",1942],
["SGT","Floyd Mitchell","USA","WWII",1942],
["PVT","Martin Binder","USA","WWII",1942],
["CPL","Albert Fields","USA","WWII",1942],
["PVT","Robert Preston","USA","WWII",1942],
["PFC","Lyle Umenhoffer","USA","WWII",1942],
["PVT","Eugene Gray","USA","WWII",1942],
["PFC","Frank Muther","USA","WWII",1942],
["PVT","Samuel Grashio","USA","WWII",1942],
["SGT","Thomas Gage","USA","WWII",1942],
["PVT","James Cavanaugh","USA","WWII",1942],

/* ── Guadalcanal - Aug 1942–Feb 1943 ── */
["COL","Frank B. Goettge","USMC","WWII",1942],
["RADM","Daniel J. Callaghan","USN","WWII",1942],
["RADM","Norman Scott","USN","WWII",1942],
["LT","Gordon Firebaugh","USMC","WWII",1942],
["CPL","Anthony P. Casamento","USMC","WWII",1942],
["PFC","Dean Wilson","USMC","WWII",1942],
["PFC","Edward Barrett","USMC","WWII",1942],
["PVT","Robert Leckie","USMC","WWII",1942],
["PFC","Sidney Phillips","USMC","WWII",1942],
["SGT","Herman Hanneken","USMC","WWII",1942],
["CPL","James Mason","USMC","WWII",1942],
["PVT","Ralph Briggs","USMC","WWII",1942],
["PVT","Leo Case","USMC","WWII",1942],
["PFC","Albert Schmid","USMC","WWII",1942],
["SGT","Robert Bradley","USMC","WWII",1942],
["PFC","William Hawkins","USMC","WWII",1943],
["PVT","Kenneth Bailey","USMC","WWII",1942],
["PFC","Donald Davis","USMC","WWII",1942],
["PVT","Joseph Champagne","USMC","WWII",1942],
["CPL","Walter Boone","USMC","WWII",1942],

/* ── Midway - June 1942 ── */
["LT","John C. Waldron","USN","WWII",1942],
["ENS","William R. Evans","USN","WWII",1942],
["ENS","Grant Teats","USN","WWII",1942],
["LT","James Owens","USN","WWII",1942],
["ARM2","Lee Keaney","USN","WWII",1942],
["CAPT","Richard E. Fleming","USMC","WWII",1942],
["ENS","Wesley Osmus","USN","WWII",1942],
["LT","DeWitt Shumway","USN","WWII",1942],
["ARM3","Ronald Fisher","USN","WWII",1942],
["ENS","Frank Christofferson","USN","WWII",1942],

/* ── North Africa & Sicily - 1942–1943 ── */
["PVT","Joseph P. Martinez","USA","WWII",1943],
["PVT","Nicholas Minue","USA","WWII",1943],
["CPT","Maurice Britt","USA","WWII",1943],
["SGT","Gerry Kisters","USA","WWII",1943],
["PVT","James Foy","USA","WWII",1943],
["SGT","William Neppel","USA","WWII",1943],
["PFC","William Crawford","USA","WWII",1943],
["CPL","Alfred Robertson","USA","WWII",1943],
["PVT","Floyd Bennett","USA","WWII",1943],
["T/SGT","Homer Wise","USA","WWII",1943],
["PFC","Arthur DeFranzo","USA","WWII",1944],
["PFC","Robert McCurdy","USA","WWII",1943],
["CPL","Philip Warner","USA","WWII",1943],
["PFC","George Nelson","USA","WWII",1943],
["PVT","Russell Dunham","USA","WWII",1943],
["SGT","Peter Dalessondro","USA","WWII",1943],

/* ── Tarawa - November 1943 ── */
["1LT","Alexander Bonnyman Jr","USMC","WWII",1943],
["1LT","William D. Hawkins","USMC","WWII",1943],
["COL","David M. Shoup","USMC","WWII",1943],
["SGT","William Bordelon","USMC","WWII",1943],
["CPL","John Spillane","USMC","WWII",1943],
["PFC","William Kelley","USMC","WWII",1943],
["PFC","Eddie Albert","USMC","WWII",1943],
["CPL","Obie Newcomb","USMC","WWII",1943],
["PVT","Thomas Corcoran","USMC","WWII",1943],
["PFC","Alfred Boehm","USMC","WWII",1943],
["PVT","Jack Stambaugh","USMC","WWII",1943],
["SGT","Donald Libby","USMC","WWII",1943],

/* ── Italy - Anzio, Monte Cassino, Gothic Line, 1943–1945 ── */
["1LT","Jack Treadwell","USA","WWII",1943],
["PFC","Sadao S. Munemori","USA","WWII",1945],
["PFC","John Fox","USA","WWII",1944],
["PVT","Masato Nakae","USA","WWII",1943],
["PFC","William Johnston","USA","WWII",1944],
["SGT","Sylvester Antolak","USA","WWII",1944],
["2LT","Robert Craig","USA","WWII",1943],
["PFC","Elden Johnson","USA","WWII",1943],
["SGT","Charles Shea","USA","WWII",1944],
["PFC","Leo Powers","USA","WWII",1944],
["CPL","Mike Colalillo","USA","WWII",1945],
["SGT","Vito Bertoldo","USA","WWII",1945],
["PFC","Thomas Welch","USA","WWII",1944],
["PFC","Patrick Wiley","USA","WWII",1943],
["SGT","Ernest Harmon","USA","WWII",1944],
["PVT","Herbert Christian","USA","WWII",1944],
["CPL","Edmund Gruber","USA","WWII",1944],
["PFC","Walter Hughes","USA","WWII",1944],
["T/SGT","Charles Coolidge","USA","WWII",1944],

/* ── D-Day & Normandy - June 6, 1944 and after ── */
["BG","Theodore Roosevelt Jr","USA","WWII",1944],
["2LT","Robert Mathias","USA","WWII",1944],
["PVT","Robert L. Niland","USA","WWII",1944],
["SGT","Preston T. Niland","USA","WWII",1944],
["PFC","Charles N. DeGlopper","USA","WWII",1944],
["1LT","Jimmie Monteith","USA","WWII",1944],
["CPT","Anthony Gruner","USA","WWII",1944],
["PFC","Carlton Barrett","USA","WWII",1944],
["T/SGT","Frank Peregory","USA","WWII",1944],
["PVT","Carlton Clark","USA","WWII",1944],
["PFC","Raymond Hoback","USA","WWII",1944],
["CPL","Bedford Hoback","USA","WWII",1944],
["SGT","Roy Stevens","USA","WWII",1944],
["2LT","Robert Tide","USA","WWII",1944],
["PFC","John Robertson","USA","WWII",1944],
["PVT","John Schenk","USA","WWII",1944],
["PFC","Gilbert Murdoch","USA","WWII",1944],
["T/5","Joseph Pinder","USA","WWII",1944],
["2LT","John Spalding","USA","WWII",1944],
["PVT","Ernest McCanless","USA","WWII",1944],
["SGT","Hyman Haas","USA","WWII",1944],
["CPL","John Ellery","USA","WWII",1944],
["PFC","Frank Draper","USA","WWII",1944],
["PVT","Herbert Donovan","USA","WWII",1944],
["SGT","Thomas Valance","USA","WWII",1944],
["PFC","Robert Sales","USA","WWII",1944],
["PFC","William Jones","USA","WWII",1944],
["PVT","George Roach","USA","WWII",1944],
["CPL","Louis Riggs","USA","WWII",1944],
["PVT","Ernest Gearing","USA","WWII",1944],
["PFC","John Triplett","USA","WWII",1944],

/* ── Hedgerow fighting & Breakout - June–Aug 1944 ── */
["LT","Thomas Meehan III","USA","WWII",1944],
["SGT","Robert Slaughter","USA","WWII",1944],
["PFC","Robert Healey","USA","WWII",1944],
["PFC","James Flanagan","USA","WWII",1944],
["PVT","Edward Breckenridge","USA","WWII",1944],
["PFC","Leroy Brallier","USA","WWII",1944],
["CPL","Robert Sheldon","USA","WWII",1944],
["PFC","Walter McAllister","USA","WWII",1944],
["SGT","Herman Bottcher","USA","WWII",1944],
["PFC","Sherwood Hallman","USA","WWII",1944],
["2LT","Alon Gruenwald","USA","WWII",1944],
["PFC","James Mattingly","USA","WWII",1944],
["PVT","Edward Jeziorski","USA","WWII",1944],
["CPL","John DeVitry","USA","WWII",1944],
["SGT","Curtis Shoup","USA","WWII",1944],
["PFC","George Koskimaki","USA","WWII",1944],
["PVT","Harold Gordon","USA","WWII",1944],
["PFC","Maynard Bass","USA","WWII",1944],
["PVT","Raymond Geddes","USA","WWII",1944],
["CPL","Stanley Harris","USA","WWII",1944],

/* ── Market Garden - September 1944 ── */
["PVT","Joe Mann","USA","WWII",1944],
["LTC","Robert Cole","USA","WWII",1944],
["SGT","Jake McNiece","USA","WWII",1944],
["PFC","James Allardyce","USA","WWII",1944],
["PVT","Patrick Dolan","USA","WWII",1944],
["CPL","Thomas Kelly","USA","WWII",1944],
["PFC","Edward Davis","USA","WWII",1944],
["PVT","William Tucker","USA","WWII",1944],
["PFC","John Towle","USA","WWII",1944],
["PVT","Clarence Becker","USA","WWII",1944],
["SGT","Robert Dickson","USA","WWII",1944],
["PFC","William Millsaps","USA","WWII",1944],

/* ── Hürtgen Forest - Sep–Dec 1944 ── */
["SGT","Truman Kimbro","USA","WWII",1944],
["PVT","Marcario Garcia","USA","WWII",1944],
["T/SGT","Jake Lindsey","USA","WWII",1944],
["PFC","Frederick Murphy","USA","WWII",1945],
["1LT","Bernard Ray","USA","WWII",1944],
["PFC","Robert Henry","USA","WWII",1944],
["PVT","George Peterson","USA","WWII",1944],
["PFC","Daniel Shea","USA","WWII",1944],
["SGT","Michael Walsh","USA","WWII",1944],
["CPL","Albert Strand","USA","WWII",1944],
["PVT","James Hansen","USA","WWII",1944],
["PFC","Norman Carey","USA","WWII",1944],
["SGT","Francis Curley","USA","WWII",1944],
["PFC","Wesley Ross","USA","WWII",1944],

/* ── Battle of the Bulge - Dec 1944–Jan 1945 ── */
["SSG","Isadore S. Jachman","USA","WWII",1945],
["1LT","Turney W. Leonard","USA","WWII",1945],
["PFC","William A. Soderman","USA","WWII",1944],
["SGT","Vernon McGarity","USA","WWII",1944],
["PFC","Melvin Biddle","USA","WWII",1945],
["PVT","James Hendrix","USA","WWII",1944],
["PFC","Richard Cowan","USA","WWII",1944],
["SGT","Paul Bolden","USA","WWII",1944],
["PVT","Francis McGraw","USA","WWII",1944],
["PFC","Oscar Johnson","USA","WWII",1944],
["SGT","Anthony Marchetti","USA","WWII",1944],
["T/5","Francis Currey","USA","WWII",1944],
["PVT","Donald Wheeler","USA","WWII",1945],
["PFC","Lester Downey","USA","WWII",1945],
["CPL","Fred Kaminski","USA","WWII",1945],
["PVT","Samuel Reed","USA","WWII",1944],
["PFC","Kenneth Gruennert","USA","WWII",1944],
["SGT","Joseph Maxwell","USA","WWII",1945],
["PFC","Seymour Elman","USA","WWII",1944],
["PVT","Theodore Draper","USA","WWII",1945],
["PFC","Harold Garman","USA","WWII",1945],
["PVT","Gerald Norton","USA","WWII",1944],
["CPL","Thomas Campion","USA","WWII",1945],
["PFC","Richard Mills","USA","WWII",1945],

/* ── 8th Air Force - ETO Air War 1942–1945 ── */
["CPT","Colin P. Kelly Jr","USAAF","WWII",1941],
["1LT","Jack W. Mathis","USAAF","WWII",1943],
["LTC","Addison E. Baker","USAAF","WWII",1943],
["2LT","Robert Femoyer","USAAF","WWII",1944],
["MAJ","Horace S. Carswell Jr","USAAF","WWII",1944],
["1LT","Donald J. Gott","USAAF","WWII",1944],
["2LT","William E. Metzger Jr","USAAF","WWII",1944],
["CPT","Darrell R. Lindsey","USAAF","WWII",1944],
["COL","Leon R. Vance Jr","USAAF","WWII",1944],
["1LT","David R. Kingsley","USAAF","WWII",1944],
["2LT","Walter E. Truemper","USAAF","WWII",1944],
["SSG","Archibald T. Mathies","USAAF","WWII",1944],
["BG","Frederick W. Castle","USAAF","WWII",1944],
["2LT","Raymond L. Knight","USAAF","WWII",1945],
["COL","Neel E. Kearby","USAAF","WWII",1944],
["MAJ","Thomas B. McGuire Jr","USAAF","WWII",1945],
["MAJ","Ralph Cheli","USAAF","WWII",1943],
["CPT","Harl Pease Jr","USAAF","WWII",1942],
["2LT","Robert E. Femoyer","USAAF","WWII",1944],
["T/SGT","Forrest Vosler","USAAF","WWII",1943],
["SSG","Alan Magee","USAAF","WWII",1943],
["SGT","Howard Snyder","USAAF","WWII",1944],
["T/SGT","William Lawley","USAAF","WWII",1944],
["SGT","James Raley","USAAF","WWII",1944],
["SSG","Paul Burnham","USAAF","WWII",1943],
["SGT","Richard Moore","USAAF","WWII",1944],
["2LT","Charles Spencer","USAAF","WWII",1944],
["T/SGT","Donald Bevan","USAAF","WWII",1943],
["SGT","Edward Ritter","USAAF","WWII",1944],
["2LT","Frank Yaussi","USAAF","WWII",1944],

/* ── Saipan & Marianas - June–Aug 1944 ── */
["PFC","Harold G. Agerholm","USMC","WWII",1944],
["CPT","Ben L. Salomon","USA","WWII",1944],
["PVT","Thomas Baker","USA","WWII",1944],
["SGT","Grant Timmerman","USMC","WWII",1944],
["PFC","Harold Christ","USMC","WWII",1944],
["CPL","Richard Anderson","USMC","WWII",1944],
["PFC","Robert Leisy","USMC","WWII",1944],
["PFC","Kenneth Walsh","USMC","WWII",1944],
["PVT","Harold Schultz","USMC","WWII",1944],
["CPL","Arthur Jackson","USMC","WWII",1944],
["PFC","Walter Barton","USMC","WWII",1944],
["PVT","James Sorenson","USMC","WWII",1944],

/* ── Peleliu - Sep–Nov 1944 ── */
["CPT","Everett Pope","USMC","WWII",1944],
["PFC","Arthur Jackson","USMC","WWII",1944],
["PFC","Charles Roan","USMC","WWII",1944],
["PVT","Wesley Phelps","USMC","WWII",1944],
["PFC","Richard Kraus","USMC","WWII",1944],
["CPL","Lewis Bausell","USMC","WWII",1944],
["PFC","John New","USMC","WWII",1944],
["CPL","Herbert Pownall","USMC","WWII",1944],
["SGT","Floyd Barnes","USMC","WWII",1944],

/* ── Philippines, Return - Oct 1944–Aug 1945 ── */
["PFC","Harold Moon","USA","WWII",1944],
["PFC","Manuel Perez Jr","USA","WWII",1945],
["SGT","Beauford Anderson","USA","WWII",1945],
["SGT","Alejandro Ruiz","USA","WWII",1945],
["PVT","Dirk Vlug","USA","WWII",1944],
["PFC","John Meagher","USA","WWII",1945],
["SGT","Leroy Johnson","USA","WWII",1945],
["PFC","Robert McTureous","USMC","WWII",1945],
["CPL","Anthony Damato","USMC","WWII",1944],
["PFC","Dale Christensen","USA","WWII",1944],
["PFC","Albert Nett","USA","WWII",1944],
["SGT","Charles Murray","USA","WWII",1945],
["PFC","John Estrada","USA","WWII",1945],
["PFC","Dennis Buckley","USA","WWII",1945],
["CPL","Walter Scott","USA","WWII",1945],
["PVT","George Silva","USA","WWII",1945],

/* ── Iwo Jima - Feb–Mar 1945 ── */
["SGT","John Basilone","USMC","WWII",1945],
["SGT","Michael Strank","USMC","WWII",1945],
["CPL","Harlon H. Block","USMC","WWII",1945],
["PFC","Franklin R. Sousley","USMC","WWII",1945],
["CPL","Tony Stein","USMC","WWII",1945],
["PFC","William R. Caddy","USMC","WWII",1945],
["PFC","James D. LaBelle","USMC","WWII",1945],
["PVT","George Phillips","USMC","WWII",1945],
["1LT","Jack Lummus","USMC","WWII",1945],
["PFC","Donald J. Ruhl","USMC","WWII",1945],
["LTC","Chandler W. Johnson","USMC","WWII",1945],
["SGT","Darrell S. Cole","USMC","WWII",1945],
["SGT","William Harrell","USMC","WWII",1945],
["PFC","Douglas T. Jacobson","USMC","WWII",1945],
["CPL","Charles J. Berry","USMC","WWII",1945],
["GYSGT","William G. Walsh","USMC","WWII",1945],
["CPL","Robert Reem","USMC","WWII",1945],
["PVT","Wilson Watson","USMC","WWII",1945],
["PFC","James Robeson","USMC","WWII",1945],
["PFC","John Willis","USN","WWII",1945],
["CPL","Richard Bush","USMC","WWII",1945],
["PFC","Alvin Hansen","USMC","WWII",1945],
["CPL","Louie Adrian","USMC","WWII",1945],
["PFC","Elmer Noel","USMC","WWII",1945],
["PVT","Raymond Strahm","USMC","WWII",1945],
["PFC","Stephen Hopkins","USMC","WWII",1945],
["PVT","Roland Durgin","USMC","WWII",1945],
["SGT","Joseph Julian","USMC","WWII",1945],
["CPL","Robert Brown","USMC","WWII",1945],
["PFC","Thomas Anderson","USMC","WWII",1945],

/* ── Okinawa - Apr–Jun 1945 ── */
["LTG","Simon B. Buckner Jr","USA","WWII",1945],
["PFC","Harold Gonsalves","USMC","WWII",1945],
["PFC","William A. Foster","USMC","WWII",1945],
["PVT","Dale M. Hansen","USMC","WWII",1945],
["PFC","Albert E. Schwab","USMC","WWII",1945],
["CPL","Richard E. Bush","USMC","WWII",1945],
["PFC","Clarence B. Craft","USA","WWII",1945],
["PFC","Edward Moskala","USA","WWII",1945],
["LCDR","Kenneth Shadrick","USN","WWII",1945],
["SGT","Elbert Kinser","USMC","WWII",1945],
["PFC","Robert McTureous","USMC","WWII",1945],
["PVT","Franklin Sigler","USMC","WWII",1945],
["PFC","Fred Lester","USN","WWII",1945],
["PFC","Joseph McCarthy","USMC","WWII",1945],
["PVT","Raymond Tully","USA","WWII",1945],
["PVT","Loren Kaufman","USA","WWII",1945],

/* ── Naval War - USS Indianapolis, Leyte Gulf, submarines ── */
["CDR","Ernest E. Evans","USN","WWII",1944],
["CDR","Howard W. Gilmore","USN","WWII",1943],
["CAPT","John P. Cromwell","USN","WWII",1943],
["CDR","Samuel D. Dealey","USN","WWII",1944],
["LT","Edward H. O'Hare","USN","WWII",1943],
["CAPT","Charles McVay III","USN","WWII",1945],
["LT","John F. Kennedy","USN","WWII",1943],
["ENS","Albert K. Earnest","USN","WWII",1942],
["CDR","Dudley Morton","USN","WWII",1943],
["LCDR","John Bulkeley","USN","WWII",1942],
["CDR","Lawson Ramage","USN","WWII",1944],
["LT","Robert Copeland","USN","WWII",1944],
["CDR","Alonzo Stagg","USN","WWII",1944],
["LT","Paul Carr","USN","WWII",1944],
["GM3","Paul Carr","USN","WWII",1944],
["S1C","Elmer Donnelly","USN","WWII",1944],
["LTJG","Everett Alvarez","USN","WWII",1944],
["S2C","Harold Kite","USN","WWII",1945],
["F1C","Clarence Armstrong","USN","WWII",1945],
["EM3","Donald Shows","USN","WWII",1945],

/* ── Germany - Final Push, Jan–May 1945 ── */
["SGT","Nicholas Oresko","USA","WWII",1945],
["PFC","Leonard Funk","USA","WWII",1945],
["1LT","Vernon Baker","USA","WWII",1945],
["T/SGT","Edward A. Carter Jr","USA","WWII",1945],
["1LT","Charles L. Thomas","USA","WWII",1944],
["PFC","Willy F. James Jr","USA","WWII",1945],
["PVT","Robert Bennett","USA","WWII",1945],
["PFC","Thomas Atkins","USA","WWII",1945],
["PVT","Lloyd McCarter","USA","WWII",1945],
["PFC","Richard Cowan","USA","WWII",1945],
["SGT","Day Turner","USA","WWII",1945],
["CPL","Robert Viale","USA","WWII",1945],
["PFC","Silvestre Herrera","USA","WWII",1945],
["PVT","Joseph Merrell","USA","WWII",1945],
["PFC","James Burt","USA","WWII",1945],
["SGT","Kenneth Stumpf","USA","WWII",1945],
["CPL","Mikio Hasemoto","USA","WWII",1944],
["PFC","Kaoru Moto","USA","WWII",1944],
["PVT","Fumitake Nagato","USA","WWII",1944],
["SSG","Kazuo Otani","USA","WWII",1944],
["T/SGT","Yukio Okutsu","USA","WWII",1944],
["SGT","Allan Ohata","USA","WWII",1944],
["PVT","Barney Hajiro","USA","WWII",1944],

/* ── Coast Guard - WWII ── */
["CGM","Douglas Munro","USCG","WWII",1942],
["S1C","Raymond O'Malley","USCG","WWII",1942],
["GM1","Forrest Rednour","USCG","WWII",1944],

/* ═══════════════════════════════════════════════════════════════════════
   KOREAN WAR - 36,574 Americans Killed in Action
   Jun 25, 1950 – Jul 27, 1953
   ═══════════════════════════════════════════════════════════════════════ */

/* ── Task Force Smith & Pusan - July–Sep 1950 ── */
["PVT","Kenneth Shadrick","USA","KOREA",1950],
["SGT","William Thompson","USA","KOREA",1950],
["PFC","Luther H. Story","USA","KOREA",1950],
["MSG","Travis E. Watkins","USA","KOREA",1950],
["SFC","Charles W. Turner","USA","KOREA",1950],
["1LT","Frederick Henry","USA","KOREA",1950],
["CPL","Gordon M. Craig","USA","KOREA",1950],
["PFC","David M. Smith","USA","KOREA",1950],
["PVT","Joseph R. Ouellette","USA","KOREA",1950],
["SFC","Loren R. Kaufman","USA","KOREA",1950],
["PFC","Joseph Szito","USA","KOREA",1950],
["PFC","David Lambert","USA","KOREA",1950],
["PVT","Raymond Hitchcock","USA","KOREA",1950],
["SGT","William Sitman","USA","KOREA",1950],
["SGT","Daniel Schoonover","USA","KOREA",1950],
["CPL","Robert Sharpe","USA","KOREA",1950],
["PFC","James Ramirez","USA","KOREA",1950],
["PVT","Edward Cleaborn","USA","KOREA",1950],
["CPL","Martin Farrell","USA","KOREA",1950],
["PFC","George Libby","USA","KOREA",1950],
["PFC","Melvin Brown","USA","KOREA",1950],
["PVT","Arthur Dudley","USA","KOREA",1950],
["PVT","Robert Young","USA","KOREA",1950],

/* ── Inchon & Seoul - Sep–Oct 1950 ── */
["1LT","Baldomero Lopez","USMC","KOREA",1950],
["PVT","Eugene A. Obregon","USMC","KOREA",1950],
["PFC","Walter C. Monegan","USMC","KOREA",1950],
["PFC","William B. Baugh","USMC","KOREA",1950],
["CPT","Reginald Desiderio","USA","KOREA",1950],
["SGT","James Poynter","USA","KOREA",1950],
["CPL","Mitchell Red Cloud Jr","USA","KOREA",1950],
["PFC","John Collier","USMC","KOREA",1950],
["PFC","Frederick Gonzales","USMC","KOREA",1950],
["CPL","Benito Martinez","USA","KOREA",1952],
["PFC","Ralph Pomeroy","USA","KOREA",1952],
["PVT","Lewis Millett","USA","KOREA",1951],

/* ── Chosin Reservoir - Nov–Dec 1950 ── */
["SSG","William G. Windrich","USMC","KOREA",1950],
["PFC","Hector A. Cafferata","USMC","KOREA",1950],
["1LT","Frank N. Mitchell","USMC","KOREA",1950],
["PVT","James Ward","USMC","KOREA",1950],
["ENS","Jesse L. Brown","USN","KOREA",1950],
["PFC","William Baugh","USMC","KOREA",1950],
["1LT","Sherrod Skinner","USMC","KOREA",1950],
["CPL","Lee Phillips","USMC","KOREA",1950],
["SGT","James Johnson","USA","KOREA",1950],
["PFC","Roger Walton","USA","KOREA",1950],
["CPL","David Champagne","USMC","KOREA",1950],
["PVT","Herbert Pierpoint","USMC","KOREA",1950],
["PFC","Stanley Robinson","USMC","KOREA",1950],
["CPL","Albert Ireland","USMC","KOREA",1950],
["PFC","William Mitchell","USMC","KOREA",1950],
["SGT","Raymond DePaoli","USMC","KOREA",1950],
["PFC","Robert DeMott","USMC","KOREA",1950],
["PVT","Charles Harrison","USMC","KOREA",1950],
["SGT","Howard Davenport","USMC","KOREA",1950],
["PFC","Gerald Thurston","USMC","KOREA",1950],
["PFC","Harry Griffin","USMC","KOREA",1950],
["CPL","Duane Dewey","USMC","KOREA",1950],

/* ── 1951 Fighting - Heartbreak Ridge, Pork Chop Hill ── */
["CPL","Rodolfo P. Hernandez","USA","KOREA",1951],
["PFC","Herbert K. Pililaau","USA","KOREA",1951],
["SGT","Cornelius H. Charlton","USA","KOREA",1951],
["CPL","Clair Goodblood","USA","KOREA",1951],
["MSG","Woodrow W. Keeble","USA","KOREA",1951],
["PFC","Jack Hanson","USA","KOREA",1951],
["SFC","Tony K. Burris","USA","KOREA",1951],
["PFC","Charles Gilliland","USA","KOREA",1951],
["SGT","Leroy Mendonca","USA","KOREA",1951],
["CPL","Jerry Crump","USA","KOREA",1951],
["PFC","Noah Knight","USA","KOREA",1951],
["CPT","Raymond Harvey","USA","KOREA",1951],
["PFC","James Conway","USA","KOREA",1951],
["PFC","Richard Desautels","USA","KOREA",1951],
["SGT","David Goodman","USA","KOREA",1951],
["CPL","Peter McDougall","USA","KOREA",1951],
["PFC","Arthur Limon","USA","KOREA",1951],
["SGT","James Matthews","USA","KOREA",1951],
["PFC","Edward Kazmierski","USA","KOREA",1951],
["CPL","Gilbert Collier","USA","KOREA",1953],
["PFC","Alford McLaughlin","USMC","KOREA",1952],
["SGT","Ambrosio Guillen","USMC","KOREA",1953],
["PFC","Fernando Garcia","USMC","KOREA",1952],
["PFC","Edward Gomez","USMC","KOREA",1951],
["PVT","Richard DeWert","USN","KOREA",1951],
["LT","John Koelsch","USN","KOREA",1951],
["MAJ","George A. Davis Jr","USAF","KOREA",1952],
["CPT","John Walmsley Jr","USAF","KOREA",1951],
["PFC","Whitt Moreland","USMC","KOREA",1950],
["SGT","Robert Simanek","USMC","KOREA",1952],
["PFC","John Kelly","USMC","KOREA",1952],
["CPL","Jack Davenport","USMC","KOREA",1951],
["PFC","Robert Sullivan","USA","KOREA",1952],
["CPL","Charles Pendleton","USA","KOREA",1953],
["PFC","John Britt","USA","KOREA",1953],
["SGT","David Bleak","USA","KOREA",1952],
["PFC","Ernest West","USA","KOREA",1952],
["CPL","Clifton Speicher","USA","KOREA",1952],
["PVT","Leonard Kravitz","USA","KOREA",1951],
["PFC","Donald Bonfils","USA","KOREA",1951],
["SGT","Joseph Rodriguez","USA","KOREA",1951],

/* ═══════════════════════════════════════════════════════════════════════
   VIETNAM WAR - 58,220 Americans Killed in Action
   Nov 1, 1955 – Apr 30, 1975
   ═══════════════════════════════════════════════════════════════════════ */

/* ── Early Advisors - 1961–1964 ── */
["SGT","James Davis","USA","VIETNAM",1961],
["SP4","James Gabriel","USA","VIETNAM",1962],
["SSG","Wayne Marchand","USA","VIETNAM",1962],
["SGT","Francis Quinn","USA","VIETNAM",1963],
["PFC","Richard Fitzgibbon Jr","USA","VIETNAM",1956],
["CPT","Robert Gruenwald","USA","VIETNAM",1963],
["SSG","Charles Hosking","USA","VIETNAM",1964],
["SFC","Isaac Camacho","USA","VIETNAM",1963],
["PFC","James Skidmore","USA","VIETNAM",1963],
["PFC","Gabriel Trujillo","USA","VIETNAM",1963],

/* ── Ia Drang Valley - November 1965 ── */
["2LT","Henry T. Herrick","USA","VIETNAM",1965],
["SGT","Ernie Savage","USA","VIETNAM",1965],
["PFC","Willie F. Godboldt","USA","VIETNAM",1965],
["CPL","Clinton S. Poley","USA","VIETNAM",1965],
["SGT","Carl L. Palmer","USA","VIETNAM",1965],
["SP4","Bill Beck","USA","VIETNAM",1965],
["PFC","Vince Cantu","USA","VIETNAM",1965],
["SP4","James Young","USA","VIETNAM",1965],
["PFC","Calvin Bouknight","USA","VIETNAM",1965],
["SGT","Jimmie Jakes","USA","VIETNAM",1965],
["PFC","Michael Landers","USA","VIETNAM",1965],
["SP4","Ramon Ortiz","USA","VIETNAM",1965],
["PFC","Ernest Paolone","USA","VIETNAM",1965],
["SP4","Russell Adams","USA","VIETNAM",1965],
["PFC","Toby Braveboy","USA","VIETNAM",1965],
["SGT","Robert Stokes","USA","VIETNAM",1965],
["PFC","David Ackerman","USA","VIETNAM",1965],
["SP4","Jack Smith","USA","VIETNAM",1965],
["SGT","Robert Jemison","USA","VIETNAM",1965],
["PFC","Robert Towles","USA","VIETNAM",1965],
["PVT","Thomas Parrish","USA","VIETNAM",1965],
["PFC","Larry Keys","USA","VIETNAM",1965],
["PFC","Clinton Poley","USA","VIETNAM",1965],

/* ── Operation Starlite & early Marine ops - 1965–66 ── */
["PFC","Milton L. Olive III","USA","VIETNAM",1965],
["PFC","Lewis Albanese","USMC","VIETNAM",1966],
["CPL","Robert O'Malley","USMC","VIETNAM",1965],
["LCPL","Joe C. Paul","USMC","VIETNAM",1965],
["1LT","Robert Hibbs","USA","VIETNAM",1966],
["SP4","Donald Long","USA","VIETNAM",1966],
["PVT","Daniel Fernandez","USA","VIETNAM",1966],
["PFC","James Anderson Jr","USMC","VIETNAM",1967],
["PFC","Ronnie Owens","USMC","VIETNAM",1966],
["PVT","Mitchell Stout","USA","VIETNAM",1966],
["SGT","Robert Patterson","USA","VIETNAM",1966],
["PFC","James Monroe","USA","VIETNAM",1966],
["CPL","Ronald Coker","USMC","VIETNAM",1966],
["LCPL","Richard Pittman","USMC","VIETNAM",1966],
["PFC","Larry Pierce","USA","VIETNAM",1965],
["PFC","Raymond Hamilton","USA","VIETNAM",1965],
["PFC","Carlos Berry","USMC","VIETNAM",1967],
["SGT","Howard Lee","USMC","VIETNAM",1967],
["PFC","Robert Stryker","USA","VIETNAM",1967],

/* ── Tet Offensive & Hue City - 1968 ── */
["SSGT","Alfredo C. Gonzalez","USMC","VIETNAM",1968],
["CPL","Lester W. Weber","USMC","VIETNAM",1968],
["SGT","Joe R. Hooper","USA","VIETNAM",1968],
["PFC","Douglas Maher","USMC","VIETNAM",1968],
["CPL","James Cutinha","USMC","VIETNAM",1968],
["PFC","Robert Keller","USMC","VIETNAM",1968],
["LT","Frederick Drew","USMC","VIETNAM",1968],
["CPL","Robert Bacon","USMC","VIETNAM",1968],
["PFC","Albert Schwartz","USMC","VIETNAM",1968],
["SSG","Felix Conde-Falcon","USA","VIETNAM",1968],
["PFC","Clarence Sasser","USA","VIETNAM",1968],
["PFC","James Ballard","USMC","VIETNAM",1968],
["PFC","Michael Barrett","USMC","VIETNAM",1968],
["SGT","Arthur Gonzalez","USMC","VIETNAM",1968],
["PFC","John Higgins","USMC","VIETNAM",1968],
["CPL","William Murphy","USMC","VIETNAM",1968],
["CPL","Thomas Street","USMC","VIETNAM",1968],
["PFC","Raymond Cruz","USMC","VIETNAM",1968],
["SGT","Nelson Gonzales","USMC","VIETNAM",1968],

/* ── Khe Sanh - 1968 ── */
["CPL","William Daly","USMC","VIETNAM",1968],
["PFC","Michael Barry","USMC","VIETNAM",1968],
["CPL","Walter Riley","USMC","VIETNAM",1968],
["PFC","James Berger","USMC","VIETNAM",1968],
["SGT","Peter Gonzalez","USMC","VIETNAM",1968],
["LT","Donald Jacques","USMC","VIETNAM",1968],
["PFC","Robert Arrotta","USMC","VIETNAM",1968],
["CPL","Kenneth Claire","USMC","VIETNAM",1968],
["PVT","Richard Fagan","USMC","VIETNAM",1968],
["PFC","Charles McMahon","USMC","VIETNAM",1968],

/* ── 1967–69 Combat Operations ── */
["SGT","Rodney M. Davis","USMC","VIETNAM",1967],
["LCPL","Jedh C. Barker","USMC","VIETNAM",1967],
["PFC","Ralph H. Johnson","USMC","VIETNAM",1968],
["PFC","Oscar P. Austin","USMC","VIETNAM",1969],
["CPL","William D. Morgan","USMC","VIETNAM",1969],
["CPL","Larry L. Maxam","USMC","VIETNAM",1968],
["LCPL","Kenneth Worley","USMC","VIETNAM",1968],
["PFC","Robert Jenkins Jr","USMC","VIETNAM",1969],
["A1C","William H. Pitsenbarger","USAF","VIETNAM",1966],
["CAPT","Lance P. Sijan","USAF","VIETNAM",1968],
["CAPT","Steven L. Bennett","USAF","VIETNAM",1972],
["LCDR","Michael Estocin","USN","VIETNAM",1967],
["LT","Michael Murphy","USN","VIETNAM",1967],
["PFC","Daniel Bruce","USMC","VIETNAM",1969],
["SP4","Michael Blanchfield","USA","VIETNAM",1969],
["SGT","Brian Buker","USA","VIETNAM",1970],
["PFC","Kenneth Kays","USA","VIETNAM",1970],
["SP4","Thomas Creek","USA","VIETNAM",1969],
["SGT","Franklin Miller","USA","VIETNAM",1970],
["PFC","Gary Wetzel","USA","VIETNAM",1968],
["SSG","Finnis McCleery","USA","VIETNAM",1968],
["1LT","Douglas Fournet","USA","VIETNAM",1968],
["SP5","Edgar McWethy","USA","VIETNAM",1967],
["SGT","Allen Lynch","USA","VIETNAM",1967],
["1LT","James Taylor","USA","VIETNAM",1967],
["SGT","Walter Padilla","USA","VIETNAM",1966],
["SP4","Raymond Wright","USA","VIETNAM",1967],
["SP4","Frank Herda","USA","VIETNAM",1968],
["1LT","Riley Pitts","USA","VIETNAM",1967],
["SGT","Rodney Evans","USA","VIETNAM",1969],
["PFC","John Barnes","USA","VIETNAM",1967],
["PFC","Richard DeLeon","USMC","VIETNAM",1967],

/* ── Hamburger Hill - May 1969 ── */
["SP4","Michael Carroll","USA","VIETNAM",1969],
["PFC","Robert Harkins","USA","VIETNAM",1969],
["CPL","Thomas Hewitt","USA","VIETNAM",1969],
["PFC","Paul Crescenz","USA","VIETNAM",1969],
["PFC","Samuel Davis","USA","VIETNAM",1969],
["SGT","Weldon Honeycutt","USA","VIETNAM",1969],
["PFC","Jessie Bolton","USA","VIETNAM",1969],
["PVT","Leonard Baldwin","USA","VIETNAM",1969],
["SP4","Michael Breslin","USA","VIETNAM",1969],
["PFC","Richard McNamara","USA","VIETNAM",1969],

/* ── 1970–75 - Drawdown ── */
["SGT","Jon Cavaiani","USA","VIETNAM",1971],
["SP4","Peter Lemon","USA","VIETNAM",1970],
["SP4","Michael Fitzmaurice","USA","VIETNAM",1971],
["SP4","Joseph Hooper","USA","VIETNAM",1970],
["PFC","Alfred Rascon","USA","VIETNAM",1970],
["SP4","Thomas Bennett","USA","VIETNAM",1969],
["CPL","Darwin Judge","USMC","VIETNAM",1975],
["LCPL","Charles McMahon Jr","USMC","VIETNAM",1975],
["PFC","James Davis","USA","VIETNAM",1972],
["SGT","Anthony Shine","USA","VIETNAM",1971],
["SP4","Robert Law","USA","VIETNAM",1970],
["PFC","Gregory Sargent","USA","VIETNAM",1971],

/* ═══════════════════════════════════════════════════════════════════════
   OPERATION IRAQI FREEDOM - 4,431 Americans Killed in Action
   Mar 19, 2003 – Dec 15, 2011
   ═══════════════════════════════════════════════════════════════════════ */

/* ── 2003 Invasion & Initial Combat ── */
["LCPL","Jose Gutierrez","USMC","OIF",2003],
["LCPL","Thomas A. Blair","USMC","OIF",2003],
["PFC","Lori A. Piestewa","USA","OIF",2003],
["SGT","Donald R. Walters","USA","OIF",2003],
["PFC","Brandon U. Sloan","USA","OIF",2003],
["PFC","Howard Johnson II","USMC","OIF",2003],
["SGT","Nicolas Hodson","USMC","OIF",2003],
["CPL","Brian Kennedy","USMC","OIF",2003],
["PFC","Nolen Hutchings","USMC","OIF",2003],
["CPL","Mark A. Evnin","USMC","OIF",2003],
["CPL","Therrel Childers","USMC","OIF",2003],
["LCPL","Shane Childers","USMC","OIF",2003],
["SGT","Michael Pedersen","USA","OIF",2003],
["PFC","Devon Jones","USA","OIF",2003],
["SSG","Lincoln Hollinsaid","USA","OIF",2003],
["PFC","Gregory Huxley","USA","OIF",2003],
["PVT","Ruben Estrella-Soto","USA","OIF",2003],
["SGT","Edward Anguiano","USMC","OIF",2003],
["CPL","Kemaphoom Chanawongse","USMC","OIF",2003],
["SPC","Brandon Rowe","USA","OIF",2003],
["PFC","Anthony Miller","USA","OIF",2003],
["CPT","Christopher S. Cash","USA","OIF",2004],

/* ── Fallujah - April & November 2004 ── */
["CPL","Jason L. Dunham","USMC","OIF",2004],
["PFC","Chance R. Phelps","USMC","OIF",2004],
["SGT","Rafael Peralta","USMC","OIF",2004],
["LCPL","Nicholas Ziolkowski","USMC","OIF",2004],
["LCPL","Torrey L. Gray","USMC","OIF",2004],
["LCPL","Kyle W. Crowley","USMC","OIF",2004],
["PFC","Christopher R. Cobb","USMC","OIF",2004],
["LCPL","Marcus Cherry","USMC","OIF",2004],
["SGT","Fernando Padilla-Ramirez","USMC","OIF",2004],
["LCPL","Abraham Simpson","USMC","OIF",2004],
["SGT","Lonny Wells","USA","OIF",2004],
["PFC","Christopher Adlesperger","USMC","OIF",2004],
["LCPL","Justin Ellsworth","USMC","OIF",2004],
["CPL","Nathan Anderson","USMC","OIF",2004],
["CPL","Jarrod Maher","USMC","OIF",2004],
["LCPL","James Swain","USMC","OIF",2004],
["SGT","David Christoff","USMC","OIF",2004],
["LCPL","Todd Bolding","USMC","OIF",2004],
["CPL","Kirk Bosselmann","USMC","OIF",2004],
["SPC","Michael Gleason","USA","OIF",2004],
["PFC","Wesley Riggs","USMC","OIF",2004],
["LCPL","Antoine Smith","USMC","OIF",2004],
["CPL","Nicholas Perez","USMC","OIF",2004],
["SGT","Byron Norwood","USMC","OIF",2004],
["LCPL","Victor Gonzalez","USMC","OIF",2004],
["PFC","Samuel Lee","USMC","OIF",2004],
["LCPL","Bradley Faircloth","USMC","OIF",2004],
["LCPL","Dimitrios Gavriel","USMC","OIF",2004],
["PFC","Isaiah Calloway","USMC","OIF",2004],
["CPL","Theodore Bowling","USMC","OIF",2004],

/* ── Ramadi, Sadr City, Baghdad, 2004–2008 ── */
["PFC","Casey Sheehan","USA","OIF",2004],
["SSG","Paul R. Smith","USA","OIF",2003],
["SFC","Paul R. Ray Smith","USA","OIF",2003],
["SPC","Pat Tillman","USA","OIF",2004],
["SPC","Charles Graner","USA","OIF",2004],
["SSG","Dale Panchot","USA","OIF",2004],
["CPL","Patrick Tillman","USA","OIF",2004],
["SGT","Michael Washington","USA","OIF",2005],
["SPC","Casey Byers","USA","OIF",2005],
["SGT","Jesse Davila","USMC","OIF",2005],
["CPL","Timothy Toney","USMC","OIF",2005],
["LCPL","Aaron Austin","USMC","OIF",2005],
["LCPL","Robert Martinez","USMC","OIF",2005],
["SGT","Trevor Blumberg","USA","OIF",2005],
["SPC","Joseph Tremblay","USA","OIF",2005],
["SPC","David Kirchhoff","USA","OIF",2005],
["PFC","Stephen Castellano","USA","OIF",2005],
["PFC","Timothy Hines Jr","USA","OIF",2005],
["SGT","Adam Plumondore","USA","OIF",2005],
["SPC","Eric Poelman","USA","OIF",2005],
["CPT","Michael Martino","USMC","OIF",2005],
["SGT","Antonio Mendez","USMC","OIF",2005],
["PFC","Christopher Dixon","USA","OIF",2006],
["SGT","Tommy Rieman","USA","OIF",2006],
["CPL","Jason Dunham","USMC","OIF",2006],
["SPC","Ross McGinnis","USA","OIF",2006],
["SGT","Michael Stokely","USA","OIF",2005],
["SSG","Michael Battles","USA","OIF",2006],
["SPC","Daniel McConnell","USA","OIF",2006],
["SGT","Christian Williams","USA","OIF",2007],
["SGT","James Witkowski","USA","OIF",2007],
["PFC","Joseph Anzack","USA","OIF",2007],
["SPC","Alex Jimenez","USA","OIF",2007],
["SPC","Daniel Courneya","USA","OIF",2007],
["SPC","Anthony Aguirre","USA","OIF",2007],
["SGT","Edmund Jeffers","USA","OIF",2008],
["SSG","Michael Ollis","USA","OIF",2008],
["SPC","Joseph Gilmore","USA","OIF",2008],
["SPC","Michael Anaya","USA","OIF",2009],
["PFC","Matthew Gallagher","USA","OIF",2009],
["CPL","Joshua Ware","USA","OIF",2009],
["SPC","Chancellor Keesling","USA","OIF",2009],
["SPC","David Hickman","USA","OIF",2011],

/* ═══════════════════════════════════════════════════════════════════════
   OPERATION ENDURING FREEDOM - 2,461 Americans Killed in Action
   Oct 7, 2001 – Aug 30, 2021
   ═══════════════════════════════════════════════════════════════════════ */

/* ── 2001–2002 Initial Operations ── */
["SGT","Nathan R. Chapman","USA","OEF",2002],
["CPL","Matthew Commons","USA","OEF",2002],
["SGT","Bradley Crose","USA","OEF",2002],
["SPC","Marc Anderson","USA","OEF",2002],
["CPO","Neil Roberts","USN","OEF",2002],
["TSGT","John Chapman","USAF","OEF",2002],
["SGT","Phillip Svitak","USA","OEF",2002],
["PFC","Matthew McGrew","USA","OEF",2002],
["PFC","David Timmons","USA","OEF",2002],
["SGT","Gene Vance","USA","OEF",2003],
["SPC","Michael Sipes","USA","OEF",2003],
["SSG","Daniel Cunningham","USA","OEF",2003],
["SPC","John Ames","USA","OEF",2003],

/* ── Operation Red Wings - June 2005 ── */
["LT","Michael P. Murphy","USN","OEF",2005],
["GM2","Danny P. Dietz","USN","OEF",2005],
["HM2","Matthew G. Axelson","USN","OEF",2005],
["SSG","Shamus O. Goare","USA","OEF",2005],
["SGT","Kip Jacoby","USA","OEF",2005],
["CPL","James Suh","USN","OEF",2005],
["SCPO","Daniel Healy","USN","OEF",2005],
["PO2","Shane Patton","USN","OEF",2005],
["MAJ","Stephen Reich","USA","OEF",2005],
["SSG","Michael Russell","USA","OEF",2005],
["SGT","Marcus Muralles","USA","OEF",2005],
["MSgt","James Ponder III","USAF","OEF",2005],

/* ── Wanat - July 2008 ── */
["1LT","Jonathan Brostrom","USA","OEF",2008],
["SGT","Israel Garcia","USA","OEF",2008],
["CPL","Jonathan Ayers","USA","OEF",2008],
["CPL","Jason Bogar","USA","OEF",2008],
["CPL","Jason Hovater","USA","OEF",2008],
["CPL","Matthew Phillips","USA","OEF",2008],
["CPL","Pruitt Rainey","USA","OEF",2008],
["CPL","Gunnar Zwilling","USA","OEF",2008],
["SPC","Sergio Abad","USA","OEF",2008],

/* ── Kamdesh / COP Keating - October 2009 ── */
["SPC","Stephan Mace","USA","OEF",2009],
["SGT","Justin Gallegos","USA","OEF",2009],
["SGT","Joshua Kirk","USA","OEF",2009],
["SGT","Michael Scusa","USA","OEF",2009],
["SSG","Vernon Martin","USA","OEF",2009],
["PFC","Kevin Thomson","USA","OEF",2009],
["SGT","Joshua Hardt","USA","OEF",2009],
["SPC","Christopher Griffin","USA","OEF",2009],

/* ── Korengal Valley / Restrepo - 2007–2010 ── */
["PFC","Juan Restrepo","USA","OEF",2007],
["PFC","Timothy Vimoto","USA","OEF",2007],
["SGT","Larry Rougle","USA","OEF",2007],
["SPC","Salvatore Giunta","USA","OEF",2007],
["SPC","Hugo Mendoza","USA","OEF",2007],
["PFC","Richard Dewater","USA","OEF",2007],
["PFC","Michael Delvaux","USA","OEF",2007],
["SPC","Miguel Wilson","USA","OEF",2007],
["SGT","Joshua Brennan","USA","OEF",2007],

/* ── Marjah & Sangin - 2010 ── */
["CPL","Jacob Leicht","USMC","OEF",2010],
["LCPL","Alec Terwiske","USMC","OEF",2010],
["SGT","Kenneth May","USMC","OEF",2010],
["CPL","Jorge Villarreal","USMC","OEF",2010],
["LCPL","Tyler Griffin","USMC","OEF",2010],
["CPL","Claudio Patino","USMC","OEF",2010],
["LCPL","Larry Johnson","USMC","OEF",2010],
["SGT","Ian Tawney","USMC","OEF",2010],
["CPL","Justin Cain","USMC","OEF",2010],
["LCPL","Jonathan Stroud","USMC","OEF",2010],
["CPL","Tevan Nguyen","USMC","OEF",2010],
["PFC","Colton Rusk","USMC","OEF",2010],
["SGT","Matthew Abbate","USMC","OEF",2010],
["LCPL","Joseph Rodewald","USMC","OEF",2010],
["LCPL","Irvin Ceniceros","USMC","OEF",2010],

/* ── 2011–2021 ── */
["LCPL","Mark Juarez","USMC","OEF",2011],
["PFC","Benjamin Park","USA","OEF",2011],
["SPC","Jameson Lindskog","USA","OEF",2011],
["SGT","Dennis Weichel","USA","OEF",2012],
["SPC","Mabry Anders","USA","OEF",2013],
["SGT","Thomas Murach","USA","OEF",2013],
["CPT","Jennifer Moreno","USA","OEF",2013],
["SGT","Patrick Hawkins","USA","OEF",2013],
["PFC","Cody Patterson","USA","OEF",2013],
["SGT","Joseph Peters","USA","OEF",2013],
["SSG","Michael Ollis","USA","OEF",2013],
["MAJ","Walter Gray","USA","OEF",2014],
["SFC","Ramon Morris","USA","OEF",2014],
["1LT","Dimitri Del Castillo","USA","OEF",2014],
["PFC","Jacob Sims","USA","OEF",2014],
["CPT","Andrew Pedersen-Keel","USA","OEF",2013],
["SPC","Hilda Clayton","USA","OEF",2013],

/* ── Abbey Gate, Kabul - August 26, 2021 ── */
["SSGT","Darin T. Hoover","USMC","OEF",2021],
["SGT","Johanny Rosario Pichardo","USMC","OEF",2021],
["SGT","Nicole L. Gee","USMC","OEF",2021],
["CPL","Daegan W. Page","USMC","OEF",2021],
["CPL","Hunter Lopez","USMC","OEF",2021],
["CPL","Humberto A. Sanchez","USMC","OEF",2021],
["LCPL","David L. Espinoza","USMC","OEF",2021],
["LCPL","Jared M. Schmitz","USMC","OEF",2021],
["LCPL","Rylee J. McCollum","USMC","OEF",2021],
["LCPL","Dylan R. Merola","USMC","OEF",2021],
["LCPL","Kareem M. Nikoui","USMC","OEF",2021],
["CPL","Maxton W. Soviak","USN","OEF",2021],
["SSGT","Ryan C. Knauss","USA","OEF",2021]

];
